function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Info/Gray");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Info/Gray",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  opacity: 0,
  x: 1,
  y: 1,
  width: 34,
  height: 34
}), /*#__PURE__*/React.createElement("g", {
  id: "streamline-icon-information-circle@36x36",
  transform: "translate(1.000000, 1.000000)",
  stroke: "#909193",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.375,23.75 L19.25,23.75 C18.008,23.75 17,22.742 17,21.5 L17,15.875 C17,15.254 16.496,14.75 15.875,14.75 L14.75,14.75",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.4375,9.125 C16.127,9.125 15.875,9.377 15.875,9.6875 C15.875,9.998 16.127,10.25 16.4375,10.25 C16.748,10.25 17,9.998 17,9.6875 C17,9.377 16.748,9.125 16.4375,9.125 L16.4375,9.125",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17,0.125 C26.3195,0.125 33.875,7.6805 33.875,17 C33.875,26.3195 26.3195,33.875 17,33.875 C7.6805,33.875 0.125,26.3195 0.125,17 C0.125,7.6805 7.6805,0.125 17,0.125 Z",
  id: "Path"
})));

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.f423876e.svg";
export { ForwardRef as ReactComponent };